module.exports = __webpack_public_path__ + "b57dfc1c4db414cf36e2fe1ac92e4d17.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-blackred-s.png
// module id = 2527
// module chunks = 0